export const truncate = (num, places) => {
    let result = +(Math.round(num + "e+" + places) + "e-" + places);
    return result.toLocaleString("es-AR");
};
export const formatNumberWithTwoDecimals = (num) => {
    return (
        num
          .toFixed(2) // always two decimal digits
          .replace('.', ',') // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      ) // use . as a separator
};
export const getNumericValue = (value) => {
    if (value === null || value === undefined || value === '') return 0;

    if (typeof value === 'number') return value;

    if (typeof value === 'string') {
        const cleanedValue = value.replace(/[^0-9,.-]+/g, '');
        const normalizedValue = cleanedValue.includes(',')
            ? cleanedValue.replace(/\./g, '').replace(',', '.')
            : cleanedValue;
        const parsedValue = parseFloat(normalizedValue);

        return Number.isNaN(parsedValue) ? 0 : parsedValue;
    }

    const parsedValue = Number(value);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
};